<template>
<div class="viBox">
<!--  <aliMediaPlayer class="mediaPlay"-->
<!--                  sourceUrl=""-->
<!--                  :coverUrl="getCover"-->
<!--                  ref="mediaPlayer"></aliMediaPlayer>-->

  <myMediaPlayer
      class="mediaPlay"
      ref="mediaPlayer"
      :isLive="isLive"
      :isLogo="isLogo"
      :isLookBack="isLookBack"
      :title="title"
      :src="srcUrl"
      :poster="poster"
      :isPosterFill="true">
  </myMediaPlayer>

<!--  <button @click="btn1" style="z-index: 9999999; position: absolute; top: 0; left: 0; width: 10vw; height: 10vw; background-color: #ead287" >mp4</button>-->
<!--  <button @click="btn2" style="z-index: 9999999; position: absolute; top: 20vw; left: 0; width: 10vw; height: 10vw; background-color: #ead287" >m3u8</button>-->

<!--  倒计时-->
  <div class="remainTime" v-if="status==1">
    <div class="surplusTime">
<!--      倒计时-->
      <div class="name">倒计时</div>
<!--      天-->
      <lvItemTime title="天" :num="day"></lvItemTime>
<!--      时-->
      <lvItemTime title="时" :num="hour"></lvItemTime>
<!--      分-->
      <lvItemTime title="分" :num="minute"></lvItemTime>
<!--      秒-->
      <lvItemTime title="秒" :num="second"></lvItemTime>
    </div>
  </div>
</div>
</template>

<script>
import lvItemTime from "./lvItemTime";
import {baseConfig} from "../../../network/baseConfig";
import myMediaPlayer from "../../../components/myMediaPlayer/myMediaPlayer";

export default {
  name: "lvVideo",
  components:{
    myMediaPlayer,
    lvItemTime
  },
  data(){
    return {
      isLive: false,
      isLogo: true,
      isLookBack: false,
      title: '',
      srcUrl: '',
      poster: '',
    }
  },
  props: {
    baseInfo: {
      type: Object,
      required: true
    },
    status: { type: Number, required: true},
    startSurplusTime: { type: Number, required: true}
  },
  mounted() {
    console.log("lvVideo: status"+this.status)
    this.title = this.baseInfo.title
    this.setLiveStatus(this.status)
  },
  watch:{
    baseInfo:{
      handler(newval, oldval){
        //设置封面
        // this.setCoverUrl(newval.image)
      }
    },
    status:{
      handler(newval, oldval){
        // console.log("-------status:"+newval)
        this.setLiveStatus(newval)
      }
    }
  },
  computed:{
    day(){
      return this.startSurplusTime/(24*60*60)
    },
    hour(){
      return (this.startSurplusTime%(24*60*60))/(60*60)
    },
    minute(){
      return (this.startSurplusTime%(60*60))/60
    },
    second(){
      return (this.startSurplusTime%(60))
    },
  },
  created() {
  },
  methods:{
    // btn1(){
    //   this.srcUrl = "https://kepu.oss.toodo.com.cn/activity/data001/1004438/mmexport1653833274495_2022_05_29_22_19_17.mp4"
    // },
    // btn2(){
    //   this.srcUrl = "https://act-pop2.toodo.com.cn/live/72/m3u8id722022_07_27_15_31_521.m3u8"
    // },
    setLiveStatus(newStatus){
      switch (newStatus){
        case 0: //未设定状态
          break;
        case 1: //未开始
            this.isLive = true

            if(this.baseInfo.image!=''){
              this.poster = this.baseInfo.image
            }

            if(this.baseInfo.isTest){
              if(this.baseInfo.http!=''){
                this.srcUrl = this.baseInfo.http
              }else{
                this.srcUrl = baseConfig.getLiveTestBaseUrl()+this.baseInfo.id+".m3u8"
              }
            }else{
              this.srcUrl = ""
            }
            break;
        case 2: //直播中
            this.isLive = true
            if(this.baseInfo.image!=''){
              this.poster = this.baseInfo.image
            }

            if(this.baseInfo.http!=''){
              this.srcUrl = this.baseInfo.http
            }else{
              this.srcUrl = baseConfig.getLiveBaseUrl()+this.baseInfo.id+".m3u8"
            }

            //临时加上，仅测试用，这里加了，就没法分享看现场直播
          // this.srcUrl = ''
          break;
        case 3: //结束
            this.isLive = false
            this.isLookBack = true

            if(this.baseInfo.recordImage!=''){
              this.poster = this.baseInfo.recordImage
            }else{
              this.poster = this.baseInfo.image
            }

            // this.src = "https://kepu-live.oss-cn-shenzhen.aliyuncs.com/record/popularization/platformLive_31/2022-08-10-19:55:02_2022-08-10-22:00:02.m3u8"
            if(this.baseInfo.record1!=''){
              this.srcUrl = this.baseInfo.record1
            }else if((this.baseInfo.isRecord)&&(this.baseInfo.record!='')){
              this.srcUrl = this.baseInfo.record
            }
          break;
        default:
          break;
      }
    }
  }
}
</script>

<style scoped>
.viBox{
  position: relative;
  width: 100%;
  height: 615px;
  background-color: #1f97c5;
}
.mediaPlay{
  width: 100%;
  height: 100%;
}
.remainTime{
  position: absolute;
  top: 400px;
  left: 45px;
  width: 990px;
  height: 150px;
  font-size: 40px;
  text-align: center;
  line-height: 150px;
  color: whitesmoke;
  background-color: rgba(24,26,25,0.8);
  border-radius: 10px;
  z-index: 199;
}
.remainTime pblock{
  position: absolute;
  font-variant: small-caps;
  white-space: pre;
}

.surplusTime{
  position: relative;
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.name{
  color: whitesmoke;
  width: 130px;
  height: 72px;
  font-size: 38px;
  line-height: 72px;
  text-align: left;
}

</style>